<script>
  import { onDestroy, createEventDispatcher } from 'svelte';
  import PuzzleBoard from './PuzzleWrapper.svelte';
  import { fade, fly, slide } from 'svelte/transition';
  import { sessionData } from '../stores';
  import {PLAYER_STATE} from "../chess-console-app/ChessConsoleAppState.js"

  import {_} from 'svelte-i18n'


  const dispatch = createEventDispatcher();


  export let token

  const serverMessageLookup = {
    'correct': 'puzzle.correct',
    'you ran out of time': 'puzzle.youRanOutOfTime',
    'something went wrong': 'puzzle.somethingWentWrong',
    'incorrect': 'puzzle.incorrect'
  }


  import { onMount } from 'svelte';

  let puzzleBoardComponent;
  let currentPuzzleInfo = null;
  let isGameOver = false;
  let isSolved = false;
  let canContinue = true;
  let timeRemaining = 12.4;
  let isTimerLow = false;
  let hundredths = 0;
  let showHundredths = false;
  let timerInterval;
  let puzzleToken = "initialToken"; // Initial token or ID for the puzzle
  let randomKey = Math.random(); // New random key for forcing re-render
  let isOutro = false; // Track if the outro animation is active
  let shouldCollapsePuzzleInfo = false;
  let showRealControls = false;
  let creditsPromise;

  onMount(() => {
    creditsPromise = fetchCredits();
  });

  const gapi_url = process.env.BASE_GAMBIT_URL;
  console.log('XXX', gapi_url);

  async function fetchCredits() {
    try {
      const response = await fetch(gapi_url + 'puzzle/puzzle_credits', {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      const data = await response.json();
      return data.credits;
    } catch (error) {
      console.error('Error fetching puzzle credits:', error);
      return 0;
    }
  }

  async function fetchPuzzleRating() {
    try {
      const response = await fetch(gapi_url + 'puzzle/puzzle_rating', {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      const data = await response.json();
      $sessionData.puzzleRating = data.rating;
    } catch (error) {
      console.error('Error fetching puzzle credits:', error);
      return 0;
    }
  }
  $: playerToMove = currentPuzzleInfo?.to_play == 1 ? 'black' : 'white';
  $: puzzleRating = currentPuzzleInfo?.puzzle_rating || 1500;
  $: computedTime = formatTime(Math.min(timeRemaining, 10));
  $: isTimerLow = timeRemaining < 5;
  $: showHundredths = timeRemaining <= 3;
  $: showRealControls = timeRemaining <= 11;
  $: colorScheme = playerToMove === 'black' ? 'dark' : 'light'; $: iconColor = colorScheme === 'dark' ? '#FFFFFF' : '#000000';


  function handleClockStop() {
    clearInterval(timerInterval);
  }

  onDestroy(() => {
    clearInterval(timerInterval);
  });

  function formatTime(seconds) {
    const cappedSeconds = Math.min(seconds, 10);
    const minutes = Math.floor(cappedSeconds / 60);
    const remainingSeconds = Math.floor(cappedSeconds % 60);
    return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`;
  }

  function formatHundredths(hundredths) {
    return `${hundredths.toString().padStart(2, '0')}`;
  }

  function startTimer() {
    clearInterval(timerInterval);
    timerInterval = setInterval(() => {
      if (timeRemaining > 0) {
        timeRemaining -= 0.01;
        hundredths = Math.floor((timeRemaining % 1) * 100);
      } else {
        clearInterval(timerInterval);
        handleTimeUp();
      }
    }, 10);
  }
function handlePuzzleInit(event) {
    currentPuzzleInfo = event.detail;
    // timeRemaining = currentPuzzleInfo.time_remaining;
    isGameOver = false;
    isSolved = false;
    // We'll start the timer when the fade-in animation is complete
  }

  function onFadeInComplete() {
    startTimer();
  }

  function handlePuzzleContinue(event) {
      const incomingTime = parseFloat(event.detail.time_remaining);
      if (incomingTime > timeRemaining) {
        timeRemaining = timeRemaining + 2;
      }
    }

  function handlePuzzleSolved(event) {
    currentPuzzleInfo = {
      ...currentPuzzleInfo,
      endGameInfo: event.detail
    };
    isGameOver = true;
    clearInterval(timerInterval);
    isSolved = event.detail.solved;
//    setTimeout(() => {
 //     shouldCollapsePuzzleInfo = true;
  //  }, 700);
    dispatch('puzzleCompleted', { correct: isSolved });
  }

  function handlePuzzleFailed(event) {
    currentPuzzleInfo = {
      ...currentPuzzleInfo,
      endGameInfo: event.detail
    };
    isGameOver = true;
    isSolved = false;
    setTimeout(() => {
      shouldCollapsePuzzleInfo = true;
    }, 2000);
    dispatch('puzzleCompleted', { correct: false });
  }

  function handleTimeUp() {
    isGameOver = true;
    isSolved = false;
    dispatch('puzzleCompleted', { correct: false });
  }

  function nextPuzzle() {
    if (canContinue) {
      isOutro = true; // Start the outro animation
      creditsPromise = fetchCredits(); // Fetch updated credits
      clearInterval(timerInterval);
    }
  }
  function onOutroComplete() {
    isGameOver = false;
    isSolved = false;
    currentPuzzleInfo = null;
    timeRemaining = 12.4;
    puzzleToken = generateNewToken();
    randomKey = Math.random(); // Generate new random key
    isOutro = false; // Reset the outro state
    fetchPuzzleRating();

    // Force re-render of PuzzleBoard
    puzzleBoardComponent = null;
  }

  function returnHome() {
    //dispatch('returnHome');
    $sessionData.playerState = PLAYER_STATE.idle
    $sessionData.cardLocked = false
  }

  function generateNewToken() {
    // Generate or fetch a new token for the next puzzle
    // For the sake of example, let's return a new random string
    return Math.random().toString(36).substr(2, 9);
  }
</script>
<div class="puzzle-wrapper">
  <div class="puzzle-container">
    <div class="puzzle-ensemble-wrapper">
      {#if !isOutro}
      {#key randomKey}
        <div
          class="puzzle-ensemble"
          in:fade={{ duration: 300 }}
          out:fade={{ duration: 300 }}
          on:introend={onFadeInComplete}
          on:outroend={onOutroComplete}
          class:outro={isOutro}
        >
          <div class="puzzle-cards-wrapper {colorScheme}">
            <!-- Chessboard -->
            <div class="puzzle-card-wrapper">
              <div class="puzzle-card">
                <div class="puzzle-content">
                  <PuzzleBoard
                    bind:this={puzzleBoardComponent}
                    stake={1.0}
                    token={token}
                    on:puzzleInit={handlePuzzleInit}
                    on:puzzleContinue={handlePuzzleContinue}
                    on:puzzleSolved={handlePuzzleSolved}
                    on:puzzleFailed={handlePuzzleFailed}
                    on:clockStop={handleClockStop}
                  />
                </div>
              </div>
            </div>

            <!-- Puzzle Data -->
            <div class="puzzle-data {colorScheme} {playerToMove}" class:expanded={isGameOver}>
              {#if currentPuzzleInfo?.init_fen}
                <!-- End Game Info -->
                {#if isGameOver && currentPuzzleInfo?.endGameInfo}
                  <div class="end-game-info {colorScheme}" transition:slide={{ duration: 300 }}>
                    <h3>
                      {#if isSolved}
                        <img src="check-all.svg" alt="Solved" class="result-icon" />
                      {:else}
                        <img src="close-circle.svg" alt="Failed" class="result-icon" />
                      {/if}
                      {isSolved ? $_('puzzle.puzzleSolved') : $_('puzzle.puzzleFailed')}
                    </h3>
                    <table class="end-game-table">
                      <tr>
                        <td><span class="icon"><img src="information-slab-box-{colorScheme === 'dark' ? 'white' : 'black'}.svg" alt="Info" /></span>{$_('puzzle.solution')}:</td>
                        <td class="solution-string">{currentPuzzleInfo.endGameInfo.solution_san}</td>
                      </tr>
                      <tr>
                        <td><span class="icon"><img src="cash-fast-{colorScheme === 'dark' ? 'white' : 'black'}.svg" alt="Cash" /></span>{$_('gameplay.balance')}:</td>
                        <td>
                          {currentPuzzleInfo.endGameInfo.newBalance.toFixed(2)}
                          <span class="delta {currentPuzzleInfo.endGameInfo.balanceDelta >= 0 ? 'positive' : 'negative'}">
                            ({currentPuzzleInfo.endGameInfo.balanceDelta.toFixed(2)})
                          </span>
                        </td>
                      </tr>
                      <tr>
                        <td><span class="icon"><img src="chart-line-{colorScheme === 'dark' ? 'white' : 'black'}.svg" alt="Chart" /></span>{$_('rating')}:</td>
                        <td>
                          {currentPuzzleInfo.endGameInfo.newRating}
                          <span class="delta {currentPuzzleInfo.endGameInfo.ratingDelta >= 0 ? 'positive' : 'negative'}">
                            ({currentPuzzleInfo.endGameInfo.ratingDelta})
                          </span>
                        </td>
                      </tr>
                      <tr>
                        <td><span class="icon"><img src="equalizer-{colorScheme === 'dark' ? 'white' : 'black'}.svg" alt="Puzzle" /></span>{$_('puzzle.puzzle')}:</td>
                        <td>
                          {currentPuzzleInfo.puzzle_rating}
                        </td>
                      </tr>
                    </table>
                    {#if currentPuzzleInfo.endGameInfo.message}
                      <p class="message">
                        <span class="icon"><img src="information-slab-box-{colorScheme === 'dark' ? 'white' : 'black'}.svg" alt="Info" /></span>
                        {$_(serverMessageLookup[currentPuzzleInfo.endGameInfo.message] || currentPuzzleInfo.endGameInfo.message)}
                      </p>
                    {/if}
                  </div>
                {/if}
              {/if}
            </div>
            <!-- Controls -->
            <div class="controls {colorScheme}">
              {#if !isGameOver}
                <div class="timer-wrapper">
                  {#if showRealControls}
                    <div
                      class="timer"
                      class:low-time={isTimerLow}
                      in:fade={{delay: 200, duration: 300}}
                    >
                      <span class:low-time={isTimerLow}>
                        {computedTime}
                        {#if showHundredths}
                          <span class="hundredths" in:fade={{ duration: 200 }}>
                            {formatHundredths(hundredths)}
                          </span>
                        {/if}
                      </span>
                    </div>
                  {:else}
                    <div class="skeleton-timer" out:fade={{duration: 200}}>
                      <div class="skeleton-loader"/>
                    </div>
                  {/if}
                </div>
              {:else}
                {#await creditsPromise}
                {:then credits}
                  {#if credits > 1}
                    <div class="button-container">
                      <button
                        class="next-button"
                        on:click={nextPuzzle}
                        disabled={!canContinue}
                      >
                        {$_('puzzle.next')}
                      </button>
                      <button
                        class="home-button"
                        on:click={returnHome}
                      >
                        {$_('gameplay.home')}
                      </button>
                    </div>
                  {:else}
                    <div class="button-container">
                      <p class="no-credits-message">
                        {credits === 1 ? $_('puzzle.lastPuzzle') : $_('puzzle.outOfCredits')}
                      </p>
                      <button
                        class="home-button"
                        on:click={returnHome}
                      >
                        home
                      </button>
                    </div>
                  {/if}
                {:catch error}
                  <div class="button-container">
                    <p class="error-message">Error loading credits</p>
                    <button
                      class="home-button"
                      on:click={returnHome}
                    >
                      home
                    </button>
                  </div>
                {/await}
              {/if}
              <div class="credits-wrapper">
                <div class="credits">
                  {#if !showRealControls}
                    <div class="skeleton-credits" out:fade={{duration: 200}}>
                      <div class="skeleton-loader"/>
                    </div>
                  {:else}
                    {#await creditsPromise}
                      <div class="skeleton-loader"/>
                    {:then credits}
                      {#if (credits > 1)}
                        <div in:fade={{delay: 400, duration: 300}}>
                          <span class="credits-number">{credits - 1}</span>
                          <span class="credits-text">{$_('puzzle.credits')}</span>
                        </div>
                      {/if}
                    {:catch error}
                      <span class="credits-error">{$_('puzzle.creditsError')}</span>
                    {/await}
                  {/if}
                </div>
              </div>
            </div>
          </div> <!-- Closes .puzzle-cards-wrapper -->
        </div> <!-- Closes .puzzle-ensemble -->
      {/key}
      {/if}
    </div> <!-- Closes .puzzle-ensemble-wrapper -->
  </div> <!-- Closes .puzzle-container -->
</div> <!-- Closes .puzzle-wrapper -->
<style>
  /* Adjust the puzzle-wrapper */
  .puzzle-wrapper {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    width: 100%;
    height: 100vh;
    margin: 0 auto;
    position: relative;
    box-sizing: border-box;
    overflow-y: auto;
    padding: 2vh 0;
  }

  /* Adjust the puzzle-container */
  .puzzle-container {
    width: 100%;
    max-width: 600px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    font-family: "Autoscape", sans-serif;
    font-size: 16px;
    padding: 1vh;
  }

  /* Adjust the puzzle-ensemble-wrapper */
  .puzzle-ensemble-wrapper {
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 1vh;
    transition: all 0.3s ease;
  }

  /* Adjust the puzzle-ensemble */
  .puzzle-ensemble {
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    flex-shrink: 1;
    flex-grow: 1;
    min-height: 0;
    overflow: auto;
    transition: opacity 300ms ease-in-out, transform 300ms ease-in-out;
  }

  /* Adjust the puzzle-cards-wrapper */
  .puzzle-cards-wrapper {
    width: 100%;
    border-radius: 8px;
    overflow: hidden;
    background-color: #47465A;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    min-height: 0;
  }

  /* Adjust the puzzle-card-wrapper */
  .puzzle-card-wrapper {
    flex: 1 1 auto;
    position: relative;
    width: 100%;
    min-height: 0;
  }

  /* Adjust the puzzle-card */
  .puzzle-card {
    width: 100%;
    aspect-ratio: 1 / 1;
    overflow: hidden;
    transition: all 0.3s ease-in-out;
    border-radius: 8px;
  }

  /* Ensure flex containers have min-height: 0 */
  .puzzle-ensemble-wrapper,
  .puzzle-ensemble,
  .puzzle-cards-wrapper {
    flex-grow: 1;
    flex-shrink: 1;
    min-height: 0;
  }

  /* Adjust the puzzle-data */
  .puzzle-data {
    flex: 0 0 auto;
    padding: 1rem;
    color: white;
    width: 100%;
    transition: all 0.3s ease-in-out;
    overflow-y: auto;
  }

  /* Adjust the controls */
  .controls {
    flex: 0 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: calc(100% - 2rem);
    margin: 1rem;
    padding: 0 1rem;
    font-size: 1rem;
    border-radius: 9px;
    transition: all 0.3s ease;
  }

  .timer-wrapper, .credits-wrapper {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 5rem;
    min-width: 8rem;
  }

  .timer, .skeleton-timer, .credits, .skeleton-credits {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .puzzle-ensemble.outro {
    animation: slideOut 0.3s ease-out forwards;
  }

  @keyframes slideOut {
    to {
      opacity: 0;
    }
  }

  .puzzle-cards-wrapper.light {
    color: #000000;
    background-color: #FFFFFF;
  }

  .puzzle-cards-wrapper.dark {
    background-color: #000000;
    color: #FFFFFF;
  }

  .puzzle-data.light {
    color: #000000;
  }

  .puzzle-data.dark {
    color: #FFFFFF;
  }

  .puzzle-data.dark .skeleton-loader {
    background: #333;
  }

  .puzzle-data.dark .skeleton-loader .line,
  .puzzle-data.dark .skeleton-loader .square {
    background: linear-gradient(to right, rgba(255, 255, 255, 0.1) 8%, rgba(255, 255, 255, 0.2) 18%, rgba(255, 255, 255, 0.1) 33%);
  }

  .puzzle-data.dark {
    background-color: #000000;
    color: #fff;
  }

  .puzzle-data.expanded {
    max-height: calc(50vh - 6rem);
  }

  .puzzle-info {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    max-height: 500px;
    overflow: hidden;
    transition: max-height 0.3s ease-out, opacity 0.3s ease-out;
  }

  .puzzle-info.collapsed {
    max-height: 0;
    margin: 0;
    padding: 0;
    opacity: 0;
  }

  .main-info {
    display: flex;
    align-items: center;
    gap: 1rem;
  }

  .player-to-move {
    font-size: 1.5rem;
    font-weight: bold;
  }

  .move-indicator {
    width: 1.5rem;
    height: 1.5rem;
    border-radius: 50%;
  }

  .metadata-table {
    display: grid;
    grid-template-columns: auto 1fr;
    gap: 0.5rem;
    font-size: 0.9rem;
  }

  .metadata-row {
    display: contents;
  }

  .metadata-label {
    font-weight: bold;
  }

  .metadata-value {
    color: inherit;
  }

  .puzzle-data.light .metadata-label,
  .puzzle-data.light .metadata-value {
    color: #000000;
  }

  .puzzle-data.dark .metadata-label,
  .puzzle-data.dark .metadata-value {
    color: #FFFFFF;
  }

  .controls.dark {
    background: #000000;
    color: white;
  }
  .controls.light {
    background: #FFFFFF;
    color: black;
  }

  .button-container {
    display: flex;
    gap: 1rem;
  }

  .correct .controls {
    background-color: #90EE90;
  }

  .incorrect .controls {
    background-color: #FFB6C1;
  }

  .timer {
    font-size: 3.5rem;
  }

  .next-button, .home-button {
    font-size: 1.2rem;
    background-color: transparent;
    border: 2px solid;
    border-radius: 5px;
    padding: 10px 20px;
    cursor: pointer;
    transition: background-color 0.3s ease, color 0.3s ease, border-color 0.3s ease;
  }

  .controls.dark .next-button,
  .controls.dark .home-button {
    color: white;
    border-color: white;
  }

  .controls.light .next-button,
  .controls.light .home-button {
    color: black;
    border-color: black;
  }

  .credits {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .credits-number { font-size: 3.5rem; }
  .credits-text { font-size: 1rem; color: #999; }

  button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  .timer.low-time { color: #FFB6C1; }

  .hundredths {
    position: absolute;
    font-size: 0.4em;
    color: #FFB6C1;
    right: -1.2em;
    top: 0.2em;
  }

  .end-game-info {

  }

  .end-game-info h3 {
    font-size: 1.2rem;
    margin-bottom: 0.5rem;
    display: flex;
    align-items: center;
    text-transform: lowercase;
  }

  .result-icon {
    width: 1.5em;
    height: 1.5em;
    margin-right: 0.5rem;
  }

  .end-game-table {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0 0.5rem;
  }

  .end-game-table td {
    padding: 0.3rem 0;
    font-weight: normal;
    text-transform: lowercase;
  }

  .end-game-table td.solution-string {
    text-transform: none;
  }

  .icon {
    display: inline-block;
    vertical-align: middle;
    margin-right: 0.5rem;
  }

  .icon img {
    width: 1em;
    height: 1em;
  }

  .delta {
    font-size: 0.8em;
    color: #999;
    margin-left: 0.5rem;
  }

  .positive { color: #4CAF50; }
  .negative { color: #F44336; }
  .message {
    font-style: italic;
    color: #666;
    margin-top: 0.5rem;
    text-transform: lowercase;
  }

  @media (max-width: 768px) {
    .controls {
      padding: 0 2rem;
      font-size: 2.5rem;
    }
    .credits-number, .timer, .next-button, .home-button {
      font-size: 2.5rem;
    }
  }

  .skeleton-loader {
    width: 100%;
    height: 2rem;
    background: linear-gradient(to right, rgba(130, 130, 130, 0.2) 8%, rgba(130, 130, 130, 0.3) 18%, rgba(130, 130, 130, 0.2) 33%);
    background-size: 800px 100px;
    animation: wave-lines 2s infinite ease-out;
    border-radius: 4px;
  }

  .skeleton-timer {
    width: 8rem;
    height: 4rem;
  }

  .skeleton-timer .skeleton-loader {
    height: 100%;
  }

  .skeleton-credits {
    width: 6rem;
    height: 5rem;
  }

  .skeleton-credits .skeleton-loader {
    height: 100%;
  }

  @keyframes wave-lines {
    0% { background-position: -468px 0; }
    100% { background-position: 468px 0; }
  }

  @keyframes wave-squares {
    0% { background-position: -468px 0; }
    100% { background-position: 468px 0; }
  }

  .credits-error {
    color: #F44336;
    font-size: 0.8rem;
  }
</style>
